import React from 'react';
import { HiOutlineExclamation, HiOutlineInformationCircle } from 'react-icons/hi';

/**
 * ConfirmModal — replaces native window.confirm() with a styled in-app modal.
 *
 * Props:
 *   open       (bool)     — show/hide
 *   title      (string)   — modal title
 *   message    (string)   — description text
 *   warning    (string?)  — optional red warning banner for dangerous actions
 *   confirmLabel (string) — label for confirm button (default "Confirmer")
 *   cancelLabel  (string) — label for cancel button (default "Annuler")
 *   danger     (bool)     — if true, confirm button is red
 *   onConfirm  (fn)       — called on confirm
 *   onCancel   (fn)       — called on cancel / overlay click
 */
export default function ConfirmModal({
  open, title, message, warning,
  confirmLabel = 'Confirmer', cancelLabel = 'Annuler',
  danger = false,
  onConfirm, onCancel,
}) {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h3>
          {danger
            ? <HiOutlineExclamation style={{ verticalAlign: 'middle', color: 'var(--accent-red)', marginRight: 8 }} />
            : <HiOutlineInformationCircle style={{ verticalAlign: 'middle', color: 'var(--accent-blue)', marginRight: 8 }} />
          }
          {title}
        </h3>
        <p>{message}</p>
        {warning && <div className="warning-text">⚠ {warning}</div>}
        <div className="modal-actions">
          <button className="btn btn-outline" onClick={onCancel}>{cancelLabel}</button>
          <button
            className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
